import axiosInstance from './axiosInstance';

// DB-backed Clapsley settings (recipients, toggles, default group JID).
// Secrets (ApiKey, BaseUrl) live in server appsettings — NOT returned by these endpoints.
export const getClapsleySettings = () =>
    axiosInstance.get('/Admin/GetClapsleySettings');

export const saveClapsleySettings = (cfg) =>
    axiosInstance.put('/Admin/SaveClapsleySettings', cfg);

// Manual triggers — Super Admin only on the backend
export const sendLeaderboardNow = () =>
    axiosInstance.post('/Admin/SendLeaderboardNow');

// Fire the Pricing-Tools + Resources digest to Telegram right now (test / on-demand).
export const sendPricingDigestNow = () =>
    axiosInstance.post('/Admin/SendPricingDigestNow');

// recipients is an optional array of JIDs / phones; empty means "use default GroupJid"
export const sendClapsleyTestMessage = (text, recipients = []) =>
    axiosInstance.post('/Admin/SendTestMessage', { text, recipients });

// Telegram smoke test — chatId empty means "use default group ChatId"
export const sendTelegramTest = (text, chatId = '') =>
    axiosInstance.post('/Admin/SendTelegramTest', { text, chatId });

// Email the Ready-to-Claim sheet (xlsx attached) now (Super Admin only).
// testTo sends the whole thing to that one address instead, with no Cc.
export const sendClaimEmailNow = (testTo = '') =>
    axiosInstance.post('/Admin/SendClaimEmailNow' + (testTo ? `?testTo=${encodeURIComponent(testTo)}` : ''));

// Broadcast an on-demand "system update" announcement to the sales group on both channels.
// `content` is substituted into {content} of the saved Announcement wrapper template.
export const sendAnnouncement = (content) =>
    axiosInstance.post('/Admin/SendAnnouncement', { content });
